import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetEdit } from '../../../../shared/components/widget-edit/widget-edit';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { ModalService } from '../../../../shared/services/modal.service';

@Component({
  selector: 'app-loans-widget',
  standalone: true,
  imports: [CommonModule, WidgetEdit, CdkOverlayOrigin],
  templateUrl: './loans.html',
  styleUrls: ['./loans.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Loans {
  @Input() title = 'LOANS';
  @Input() size: 'small' | 'medium' | 'half' | 'full' = 'medium';
  @Input() index = 0;
  @Input() isEditMode = false;
  @Input() isAddMode = false;
  @Output() addWidget = new EventEmitter<void>();
  @Input() activeDropdownIndex: number | null = null;
  @Input() getAvailableSizes!: (index: number) => Array<{ value: string; label: string }>;
  @Input() toggleSizeDropdown!: (index: number, event: Event) => void;
  @Input() changeWidgetSize!: (index: number, size: any) => void;
  @Input() removeWidget!: (index: number) => void;

  // Replace with real data later (via @Input or service)
  loan = {
    total: 730000.55,
    paidPercent: 50,
    emi: 12500,
  };

  get remaining(): number {
    return this.loan.total * (1 - this.loan.paidPercent / 100);
  }

  get paidAmount(): number {
    return this.loan.total * (this.loan.paidPercent / 100);
  }

  constructor(private modalService: ModalService) {}

  openModal() {
    if (!this.isEditMode && !this.isAddMode) {
      // this.modalService.openLoansModal?.() || console.log('Loans details modal');
    }
  }
}